import React from 'react';
import Header from './components/layout/Header';
import SkillsTerminal from './components/skills/SkillsTerminal';
import Timeline from './components/timeline/Timeline';
import ProjectGrid from './components/projects/ProjectGrid';
import ContactSection from './components/contact/ContactSection';
import Footer from './components/layout/Footer';
import BlogPosts from './components/blogs/BlogPosts'
import Education from './components/education/Education';
import { Routes, Route } from 'react-router-dom'; // Add this import
import Starfield from './components/effects/Starfield';
// import FloatingShip from './components/effects/FloatingShip';


const Home = () => {
  return (
    <>
      <Header />
      <SkillsTerminal />
      <Timeline />
      <ProjectGrid />
      <Education />
      <ContactSection />
      <Footer />
    </>
  );
};

const App = () => {
  return (
    <div className="bg-black text-green-500 min-h-screen">
      <Starfield />
      {/* <FloatingShip /> */}
      <div className="max-w-6xl mx-auto px-4 relative z-10">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/blogs" element={<BlogPosts />} />
        </Routes>
      </div>
    </div>
  );
};

export default App;